import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

export const WomanWithTabletAndGlasses = ({ style, grow }: SVGIconProps) => {
  return (
    <Center style={style} classNames={classNames} data-grow={grow}>
      <svg
        width="447"
        height="316"
        viewBox="0 0 447 316"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="133.392"
          cy="128.111"
          rx="7.07651"
          ry="6.90861"
          transform="rotate(-43.3865 133.392 128.111)"
          fill="#E0E3FE"
        />
        <ellipse
          cx="152.378"
          cy="126.001"
          rx="7.01046"
          ry="6.84823"
          transform="rotate(-43.35 152.378 126.001)"
          fill="#E0E3FE"
        />
        <path
          d="M296.021 313.674C301.311 313.674 306.455 313.438 311.453 312.966C345.198 309.854 371.878 296.551 389.62 277.978C399.006 268.297 406.103 256.637 410.391 243.854C414.43 231.753 415.608 218.879 413.832 206.246C401.571 119.161 298.597 161.508 341.766 108.542C384.935 55.5748 300.426 -11.7916 267.999 4.15158C235.572 20.0947 271.332 54.1933 191.199 38.0732C111.065 21.953 127.647 92.7804 127.647 92.7804"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M80.2746 238.516C80.2746 238.516 43.5754 212.199 29.407 241.303C29.407 241.303 44.3079 188.494 95.1313 169.606C95.1313 169.606 109.659 161.524 110.298 166.405C110.937 171.287 115.15 173.78 116.994 173.721C118.837 173.662 134.402 174.635 134.942 172.31C135.483 169.984 134.451 163.018 142.169 162.969C149.888 162.92 191.768 173.209 203.744 184.084C203.744 184.084 182.9 209.25 194.045 236.997L184.655 234.72C184.655 234.72 190.446 284.865 182.551 314.033H46.176C46.176 314.033 59.8086 315.749 73.7902 305.774L94.094 279.718C94.094 279.718 102.997 266.228 121.187 264.301C121.187 264.301 131.54 263.17 131.442 258.249C131.344 253.328 135.174 261.401 140.291 254.287C140.916 254.287 153.354 255.005 153.354 255.005C153.354 255.005 162.694 255.88 164.449 247.542C166.204 239.204 172.674 180.682 170.349 177.167C168.023 173.652 167.134 173.608 147.508 173.726C127.883 173.843 110.637 169.93 108.139 179.694C105.642 189.457 102.756 226.451 102.756 226.451C102.756 226.451 91.6949 229.347 83.2686 241.328C83.2981 241.323 80.2746 247.163 80.2746 238.516Z"
          fill="#E0E3FE"
        />
        <path d="M80.275 220.744V243.781" stroke="#3C0789" strokeWidth="2.8" />
        <path
          d="M184.026 232.261C205.682 243.765 265.531 267.27 267.655 176.866C267.655 176.866 265.079 153.126 271.794 150.029C278.51 146.931 289.34 137.124 275.393 113.379L284.493 104.298C286.149 102.594 286.77 100.135 286.122 97.8485C285.474 95.5618 283.655 93.7946 281.351 93.2125C279.047 92.6304 276.607 93.3219 274.95 95.0265L256.864 114.2C256.864 114.2 254.244 109.283 249.598 111.845C244.952 114.406 227.913 125.276 235.651 147.974L215.524 205.788"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M256.839 114.189C256.839 114.189 261.662 121.529 251.397 129.031"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M278.362 119.082C278.362 119.082 281.366 128.516 269.248 134.602C264.961 136.756 260.256 132.223 262.281 127.872C262.316 127.808 262.345 127.739 262.38 127.671"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M282.03 130.732C282.03 130.732 279.38 139.945 272.129 140.388C265.713 140.776 266.79 134.233 266.79 134.233"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M157.974 124.961C157.483 125.088 157.173 124.68 156.716 124.759C150.143 123.559 145.256 118.368 144.705 115.871C144.892 117.232 147.39 117.095 146.967 118.486C146.888 118.751 146.731 118.648 146.603 118.904C146.397 119.395 146.402 118.722 146.112 119.164C144.499 116.78 143.565 115.595 143.28 114.283C143.474 115.691 143.36 117.125 142.946 118.486C142.87 118.752 142.769 119.01 142.646 119.258C141.662 121.578 139.612 123.54 136.186 124.026C135.327 124.135 134.459 124.163 133.595 124.11C131.137 123.967 129.013 123.825 127.204 123.746C121.157 123.476 118.989 123.933 119.667 127.836C120.041 129.602 120.571 131.331 121.25 133.003C122.45 136.16 123.286 141.626 122.057 147.58V147.614C120.631 154.546 116.118 159.905 106.448 164.939C104.735 165.823 102.968 166.6 101.158 167.264C84.3791 173.488 44.2435 189.254 27.6072 247.068C25.8374 253.228 24.5149 258.833 23.5808 263.951L23.1236 263.685C11.7624 256.876 4.35368 241.602 6.60529 228.461C7.72617 221.937 11.9737 217.385 17.4209 213.958C21.2456 211.588 25.3359 209.647 28.7625 206.721C40.1188 197.022 31.0387 181.939 37.3264 170.342C44.4156 157.294 55.5163 149.251 70.0092 148.588C73.657 148.745 77.762 149.173 81.7441 148.981C87.5255 149.187 93.4347 148.715 97.6676 144.925C101.001 141.975 101.694 137.167 102.957 133.156C104.38 128.632 105.566 124.037 106.512 119.391C107.377 114.985 108.989 110.76 111.28 106.899C113.754 102.714 117.242 99.2211 121.422 96.7417C125.069 94.6833 129.135 93.4782 133.315 93.2168C137.121 93.4412 140.823 94.5452 144.13 96.4418C145.26 97.1093 146.327 97.876 147.321 98.7327C154.641 104.976 158.146 115.546 157.974 124.961Z"
          fill="#3C0789"
        />
        <path
          d="M269.04 139.84C269.04 139.84 266.695 142.75 267.978 145.513C269.261 148.276 272.447 148.92 275.544 147.711"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M275.382 113.381L268.903 119.855"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M102.78 225.818L108.055 180.343C108.497 176.535 111.723 173.662 115.557 173.662H164.001C166.145 173.661 168.188 174.571 169.621 176.165C171.054 177.76 171.742 179.888 171.513 182.02L164.454 247.547C164.039 251.384 160.801 254.292 156.942 254.292H139.607"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <circle cx="160.04" cy="183.268" r="1.97667" fill="#3C0789" />
        <path
          d="M127.416 236.365C132.528 237.516 133.551 237.535 138.511 238.273C141.638 238.74 148.786 239.128 148.914 234.276C149.032 230.014 144.249 227.511 140.871 226.15C136.973 224.667 132.894 223.713 128.743 223.313C127.032 223.116 125.313 222.982 123.586 222.91C111.615 222.418 97.8055 225.314 89.5611 234.679C70.4618 256.35 45.0648 270.282 45.0648 270.282"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M141.107 238.516C143.565 239.558 147.729 241.78 146.023 246.037C145.247 248.004 143.836 248.702 141.899 248.987C137.715 249.592 133.227 248.702 129.117 247.842C127.598 247.522 124.904 246.937 123.404 246.524"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M136.737 249.086C136.737 249.086 141.205 249.032 140.129 253.186C138.354 260.069 124.564 256.952 118.114 255.506"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M137.011 163.342C158.023 164.261 190.042 170.421 219.077 195.538"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M184.026 222.861C184.026 222.861 188.942 268.616 184.026 313.678"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          opacity="0.54"
          d="M400.986 201.964L444.195 91.2466C445.28 86.9058 444.305 82.307 441.552 78.7799C438.799 75.2528 434.574 73.1906 430.1 73.1895H258.452C250.518 73.1883 243.619 78.6263 241.766 86.3402L194.453 197.033C193.412 201.361 194.413 205.928 197.169 209.425C199.924 212.921 204.13 214.962 208.582 214.962H384.335C392.211 214.963 399.076 209.604 400.986 201.964Z"
          fill="white"
        />
        <path
          d="M400.986 201.964L444.195 91.2466C445.28 86.9058 444.305 82.307 441.552 78.7799C438.799 75.2528 434.574 73.1906 430.1 73.1895H258.452C250.518 73.1883 243.619 78.6263 241.766 86.3402L194.453 197.033C193.412 201.361 194.413 205.928 197.169 209.425C199.924 212.921 204.13 214.962 208.582 214.962H384.335C392.211 214.963 399.076 209.604 400.986 201.964Z"
          fill="#E0E3FE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M400.986 201.964L444.195 91.2466C445.28 86.9058 444.305 82.307 441.552 78.7799C438.799 75.2528 434.574 73.1906 430.1 73.1895H258.452C250.518 73.1883 243.619 78.6263 241.766 86.3402L194.453 197.033C193.412 201.361 194.413 205.928 197.169 209.425C199.924 212.921 204.13 214.962 208.582 214.962H384.335C392.211 214.963 399.076 209.604 400.986 201.964V201.964Z"
          stroke="#3C0789"
          strokeWidth="2.8"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M394.664 197.479L434.529 95.3357C435.529 91.3322 434.63 87.0912 432.091 83.8381C429.553 80.585 425.657 78.6822 421.531 78.6797H263.166C255.847 78.6778 249.481 83.6955 247.774 90.8128L204.123 192.932C203.163 196.925 204.087 201.138 206.63 204.363C209.173 207.588 213.054 209.47 217.161 209.47H379.306C386.569 209.466 392.899 204.524 394.664 197.479Z"
          fill="#3C0789"
        />
        <path
          d="M387.271 99.2738H410.224C412.37 99.2733 414.313 98.004 415.175 96.039C415.31 95.744 415.382 95.4243 415.386 95.1C415.376 93.7955 414.316 92.7429 413.012 92.7402H388.593C389.758 94.6821 389.178 97.3664 387.271 99.2738Z"
          fill="#FF5636"
        />
        <path
          d="M372.428 96.919C372.43 98.2203 373.486 99.2738 374.787 99.2738H387.27C389.177 97.3664 389.757 94.6821 388.612 92.7402H377.59C375.446 92.7391 373.504 94.0041 372.639 95.9652C372.505 96.2658 372.434 96.5901 372.428 96.919H372.428Z"
          fill="#E0E3FE"
        />
        <path
          d="M382.576 99.2756C382.64 99.4017 382.716 99.5218 382.802 99.6345C384.439 101.871 387.988 102.093 390.751 100.067C391.078 99.8261 391.387 99.5616 391.676 99.2756C393.583 97.3682 394.163 94.6839 393.018 92.7421C392.953 92.6176 392.877 92.4992 392.792 92.3881C391.169 90.1365 387.62 89.93 384.857 91.9407C384.526 92.1856 384.212 92.4534 383.918 92.7421C382.025 94.6544 381.445 97.3239 382.576 99.2756Z"
          fill="white"
        />
        <path
          d="M366.657 111.324C366.667 112.628 367.727 113.679 369.031 113.679H393.12C391.955 111.713 392.535 109.058 394.448 107.15H371.833C369.688 107.151 367.745 108.42 366.883 110.385C366.745 110.68 366.668 110.999 366.657 111.324Z"
          fill="#E0E3FE"
        />
        <path
          d="M393.114 113.679H404.422C406.564 113.681 408.506 112.418 409.372 110.459C409.508 110.159 409.58 109.834 409.584 109.505C409.585 108.88 409.337 108.281 408.895 107.839C408.453 107.397 407.854 107.149 407.229 107.15H394.442C392.525 109.058 391.949 111.727 393.114 113.679Z"
          fill="#FF5636"
        />
        <path
          d="M388.601 113.68C388.652 113.81 388.721 113.93 388.807 114.039C390.435 116.291 393.984 116.497 396.742 114.487C397.077 114.244 397.391 113.974 397.681 113.68C399.574 111.773 400.139 109.103 399.023 107.152C398.96 107.026 398.886 106.906 398.802 106.793C397.16 104.556 393.61 104.335 390.853 106.36C390.524 106.599 390.215 106.863 389.928 107.152C388.011 109.059 387.436 111.729 388.601 113.68Z"
          fill="white"
        />
        <path
          d="M385.092 127.985H399.511C401.654 127.986 403.596 126.721 404.461 124.76C404.597 124.465 404.669 124.145 404.673 123.821C404.667 122.512 403.607 121.454 402.298 121.451H386.434C387.565 123.403 386.984 126.072 385.092 127.985H385.092Z"
          fill="#E0E3FE"
        />
        <path
          d="M361.721 125.64C361.726 126.938 362.782 127.987 364.08 127.985H385.092C386.985 126.072 387.55 123.403 386.434 121.451H366.883C364.737 121.452 362.794 122.721 361.932 124.686C361.797 124.986 361.725 125.311 361.721 125.64Z"
          fill="#FF5636"
        />
        <path
          d="M377.594 127.984C377.659 128.108 377.735 128.227 377.821 128.338C379.443 130.59 382.992 130.796 385.755 128.785C386.087 128.54 386.4 128.273 386.694 127.984C388.587 126.072 389.152 123.402 388.036 121.45C387.972 121.324 387.896 121.204 387.81 121.092C386.173 118.855 382.624 118.663 379.861 120.659C379.534 120.9 379.225 121.164 378.937 121.45C377.029 123.358 376.429 126.042 377.594 127.984Z"
          fill="white"
        />
        <path
          d="M291.871 195.46H306.29C308.434 195.461 310.376 194.196 311.241 192.235C311.576 191.505 311.512 190.655 311.073 189.983C310.634 189.311 309.88 188.912 309.078 188.926H293.218C294.344 190.878 293.764 193.547 291.871 195.46H291.871Z"
          fill="#E0E3FE"
        />
        <path
          d="M234.627 193.114C234.628 193.738 234.877 194.335 235.319 194.775C235.761 195.214 236.359 195.461 236.982 195.459H291.871C293.764 193.547 294.329 190.878 293.213 188.926H239.789C237.643 188.926 235.701 190.196 234.839 192.161C234.704 192.461 234.632 192.785 234.627 193.114Z"
          fill="#FF5636"
        />
        <path
          d="M282.772 195.459C282.837 195.583 282.912 195.702 282.998 195.813C284.62 198.069 288.17 198.271 290.933 196.26C291.264 196.015 291.578 195.747 291.872 195.459C293.764 193.546 294.33 190.877 293.214 188.925C293.149 188.799 293.073 188.679 292.988 188.566C291.346 186.329 287.796 186.138 285.038 188.134C284.711 188.375 284.402 188.639 284.114 188.925C282.206 190.833 281.626 193.517 282.772 195.459Z"
          fill="white"
        />
        <path
          d="M24.4024 266.272C22.5716 265.55 20.8011 264.684 19.1076 263.681C7.73653 256.873 0.327861 241.603 2.58438 228.457C3.71019 221.933 7.95776 217.386 13.4245 213.954C17.2444 211.585 21.3543 209.648 24.7662 206.723C36.1225 197.023 27.0374 181.935 33.3252 170.343C40.9699 156.283 53.2603 148.038 69.4542 148.574C77.2266 148.83 87.3195 150.614 93.6663 144.926C96.9995 141.977 97.6976 137.169 98.961 133.157C100.385 128.633 101.573 124.039 102.52 119.392C103.371 114.987 104.975 110.761 107.26 106.9C109.732 102.711 113.22 99.2133 117.402 96.7282C125.267 92.1906 136.235 91.7727 144.141 96.4382C145.266 97.1073 146.332 97.8721 147.326 98.7242C154.642 104.997 158.142 115.562 157.975 124.981"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M143.118 113.453C143.526 116.226 145.213 118.782 148.207 119.549C151.589 120.41 153.383 123.703 154.337 127.012C155.692 131.866 155.345 137.038 153.354 141.667C151.505 146.023 148.212 151.008 142.642 151.789C132.45 153.264 127.377 148.948 127.377 148.948"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <circle cx="134.628" cy="126.516" r="1.75048" fill="#3C0789" />
        <circle cx="150.021" cy="125.356" r="1.75048" fill="#3C0789" />
        <path
          d="M130.567 257.458C133.113 259.021 131.058 261.597 129.21 262.467C126.034 263.942 121.929 264.203 118.468 264.616C92.1519 267.713 83.5183 301.785 67 308.5C50.4817 315.215 6.00085 322.174 27.6222 247.065C44.2683 189.261 84.404 173.494 101.183 167.27C102.989 166.607 104.752 165.832 106.463 164.95C116.133 159.926 120.661 154.547 122.082 147.611C122.082 147.611 122.082 147.611 122.082 147.581C123.311 141.628 122.485 136.161 121.28 133C120.589 131.33 120.053 129.601 119.678 127.833C118.783 122.804 122.667 123.512 133.571 124.111C138.575 124.406 141.407 122.145 142.626 119.264C142.746 119.014 142.843 118.754 142.916 118.487C143.429 116.856 143.49 115.116 143.093 113.453"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M142.17 126.938C142.17 126.938 144.008 133.658 143.821 134.651C143.635 135.644 141.28 134.877 141.28 134.877"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M134.087 143.578C137.281 142.042 141.139 142.595 142.777 144.662"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <ellipse
          cx="131.961"
          cy="127.866"
          rx="8.1756"
          ry="7.97895"
          transform="rotate(-43.35 131.961 127.866)"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <ellipse
          cx="152.379"
          cy="126"
          rx="8.1756"
          ry="7.97895"
          transform="rotate(-43.35 152.379 126)"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M151.918 119.265C152.129 119.236 152.34 119.236 152.547 119.236V119.191C156.052 119.178 158.955 121.907 159.159 125.406C159.385 129.166 156.588 132.429 152.837 132.78C152.626 132.809 152.414 132.809 152.208 132.809C148.718 132.825 145.819 130.122 145.591 126.639C145.373 122.88 148.168 119.621 151.918 119.265ZM157.98 125.465C157.8 122.602 155.416 120.378 152.547 120.396V120.421H152.026C148.903 120.715 146.579 123.436 146.776 126.566C146.98 129.41 149.357 131.606 152.208 131.585H152.729C155.842 131.292 158.163 128.586 157.98 125.465Z"
          fill="white"
        />
        <path
          d="M140.026 127.134L144.313 126.741"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M131.487 120.92C131.703 120.9 131.919 120.891 132.136 120.891V120.935C135.71 120.92 138.679 123.69 138.91 127.257C139.144 131.114 136.277 134.462 132.43 134.823C132.214 134.853 131.998 134.853 131.786 134.853C128.211 134.868 125.241 132.098 125.007 128.53C124.745 124.656 127.62 121.279 131.487 120.92ZM137.73 127.315C137.552 124.363 135.092 122.07 132.135 122.099V122.074C131.955 122.072 131.774 122.081 131.595 122.099C128.389 122.4 125.998 125.187 126.187 128.401C126.367 131.354 128.828 133.649 131.786 133.622H132.322C135.53 133.321 137.922 130.531 137.73 127.315Z"
          fill="white"
        />
        <path
          d="M114.629 173.72C112.466 171.463 110.588 168.145 109.354 163.342"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <path
          d="M134.628 173.662L137.012 163.343L139.603 152.223"
          stroke="#3C0789"
          strokeWidth="2.8"
        />
        <ellipse
          cx="137.178"
          cy="213.283"
          rx="8.30833"
          ry="7.34476"
          transform="rotate(-78.48 137.178 213.283)"
          fill="#C5C9F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M296.448 287.902L292.416 310.428C292.183 311.733 291.048 312.684 289.722 312.685H268.637C267.296 312.686 266.152 311.716 265.933 310.394L262.246 287.902L296.448 287.902Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M300.283 285.385C300.165 286.806 298.98 287.899 297.554 287.902H261.175C259.77 287.902 258.592 286.841 258.446 285.444C258.373 284.676 258.627 283.912 259.147 283.341C259.666 282.77 260.403 282.445 261.175 282.445H297.554C298.315 282.446 299.042 282.763 299.559 283.321C300.077 283.879 300.339 284.626 300.283 285.385Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M280.51 282.407C280.51 281.251 283.46 266.862 281.002 254.104C279.665 247.103 276.715 240.599 270.776 237.035"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M281.011 254.125C281.011 254.125 281.685 244.43 290.062 243.762"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M281.911 268.916C284.294 267.246 287.165 266.416 290.072 266.556"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M281.911 262.028C281.911 262.028 275.824 254.821 266.1 260.524"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M277.619 259.128C277.619 259.128 263.913 246.611 261.229 263.552C261.229 263.552 265.088 266.064 270.786 263.552C276.484 261.04 277.619 259.128 277.619 259.128Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M284.025 246.711C284.025 246.711 283.533 241.077 290.062 239.234C296.591 237.39 300.293 245.104 300.293 245.104C300.293 245.104 295.254 250.674 284.025 246.711V246.711Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          d="M285.539 266.552C285.539 266.552 285.313 260.854 292.913 262.029C300.513 263.204 301.762 269.688 301.762 269.688C301.762 269.688 289.314 274.25 285.539 267.151"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M276.38 242.325C276.38 242.728 270.668 241.833 270.304 241.706C267.536 240.88 265.57 238.962 264.277 236.426C263.878 235.639 261.573 231.229 262.227 230.462C262.246 230.462 275.825 226.087 276.38 242.325Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M410.4 243.854C406.113 256.638 399.015 268.3 389.629 277.982C371.877 296.555 345.197 309.858 311.462 312.97V243.854H410.4Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M389.629 277.982C371.877 296.556 345.197 309.859 311.462 312.971V277.982H389.629Z"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
        <rect
          x="369.375"
          y="256.605"
          width="9.98475"
          height="9.98475"
          rx="4.99237"
          stroke="#C5C9F0"
          strokeWidth="2.8"
        />
      </svg>
    </Center>
  );
};
